var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6386 5.94116C18.383 5.94116 17.2246 5.52522 16.2943 4.82354C15.2274 4.01917 14.4608 2.83925 14.1901 1.47929C14.1231 1.14327 14.087 0.796514 14.0836 0.441162H10.497V10.2415L10.4927 15.6096C10.4927 17.0447 9.55809 18.2616 8.26259 18.6896C7.88661 18.8137 7.48055 18.8726 7.05774 18.8494C6.51805 18.8198 6.01231 18.6569 5.57274 18.3939C4.63731 17.8345 4.00309 16.8196 3.98591 15.6585C3.95884 13.844 5.42579 12.3646 7.23907 12.3646C7.597 12.3646 7.94075 12.423 8.26259 12.5291V9.85046V8.88753C7.92313 8.83726 7.57766 8.81104 7.22833 8.81104C5.2436 8.81104 3.38735 9.63605 2.06048 11.1223C1.05759 12.2455 0.456023 13.6785 0.36321 15.1812C0.241609 17.1551 0.963913 19.0316 2.36469 20.416C2.57051 20.6193 2.78665 20.8079 3.01266 20.9819C4.21364 21.9062 5.68188 22.4072 7.22833 22.4072C7.57766 22.4072 7.92313 22.3814 8.26259 22.3312C9.7072 22.1172 11.0401 21.4559 12.092 20.416C13.3845 19.1386 14.0986 17.4426 14.1063 15.6375L14.0879 7.62124C14.7045 8.0969 15.3786 8.4905 16.1022 8.79601C17.2276 9.27081 18.4208 9.51144 19.6489 9.51101V6.90667V5.9403C19.6497 5.94116 19.6394 5.94116 19.6386 5.94116Z",
    fill: "#003A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.3b29dbb73a7a702c3ac2bb441ad5fd0b.svg";
export { ForwardRef as ReactComponent };